var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('subTopicTemplate',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var topic = ref.topic;
var subTopic = ref.subTopic;
return [_c('videoSelectQuestion',{attrs:{"topic":topic,"subTopic":subTopic}})]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01dbc8fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"audio":["src"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/library/units/topics/subtopics/videoSelectQuestion.vue
// module id = 1337
// module chunks = 22